import { isNativeApp } from './platform';

/** Web marketing site hosts the product SPA under `/app`. Native Capacitor keeps `/`. */
export function appBase(): string {
  return isNativeApp() ? '' : '/app';
}

/** Prefix in-app paths for the current platform. */
export function appPath(path = '/'): string {
  const normalized = !path || path === '/' ? '/' : path.startsWith('/') ? path : `/${path}`;
  const base = appBase();
  if (!base) return normalized;
  if (normalized === '/') return base;
  return `${base}${normalized}`;
}

/** Auth/marketing pages stay at the site root on web. */
export function authPath(path: '/login' | '/signup' | '/download' | '/privacy' | '/terms' | '/'): string {
  if (isNativeApp()) {
    if (path === '/download') return '/';
    return path === '/' ? '/' : path;
  }
  return path;
}

export function isWebMarketingHost(): boolean {
  return !isNativeApp();
}
